"use client";

export { SearchRecommendationPill } from "./SearchRecommendationPill";
export type { IProps } from "./SearchRecommendationPill";
